import { IEnvironment } from './IEnvironment';

export const sharedEnv: IEnvironment = {
    baseApiUrl: 'https://platform.controltower.tech/api',
    baseRealTimeUrl: 'https://platform.controltower.tech',
    auth0: {
        domain: 'auth.controltowerapp.com',
        authorizationParams: {
            audience: 'https://platform.controltower.tech/api/',
        },
    },
    jwtConfig: {
        allowedList: [
            'platform.controltower.tech',
            'demoloads.api.controltowerapp.com',
            'parts.api.controltower.tech',
        ],
        disallowedList: [/\/one-time-links\/[a-f\d-]+\/authenticate/],
    },
    assetsSource:
        'https://pf-prod-public-files.controltower.tech/assets-branding/icons',
};
